import { render } from "./BenefitMessaging.vue?vue&type=template&id=ff6a8b7e"
import script from "./BenefitMessaging.vue?vue&type=script&lang=js"
export * from "./BenefitMessaging.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__